export default defineAppConfig({
    ui: {
        primary: 'blue',
        gray: 'slate',
        
        tabs: {
            wrapper:'space-y-0',
            list: {
                height: 'h-auto',
                tab: {
                height: 'h-[30px]'
                }
            }
        }
    }
})
